module.exports = __webpack_public_path__ + "img/about.09891474.jpg";